import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-af58b51a")

_pushScopeId("data-v-af58b51a")
const _hoisted_1 = { class: "customer_info_table" }
const _hoisted_2 = { class: "customer_info_table_header" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "text"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_tag = _resolveComponent("van-tag")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
      return (_openBlock(), _createBlock("p", {
        key: item.name
      }, [
        _createVNode("span", _hoisted_3, _toDisplayString(item.name), 1),
        _hoisted_4,
        (Array.isArray(item.value))
          ? (_openBlock(), _createBlock("span", _hoisted_5, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.value, (v) => {
                return (_openBlock(), _createBlock(_component_van_tag, {
                  class: "enumTag",
                  key: v
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(v), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]))
          : (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(item.value), 1))
      ]))
    }), 128))
  ]))
})